import { Section, Eyebrow, Heading } from './home-ui';
import { RevealGroup, RevealItem } from '../../../Utils/Animate/reveal-component';

export default function Audience({ data }) {
    if (!data) return null;
    const { eyebrow, titleLine1, titleLine2, paragraph, cards = [] } = data;

    return (
        <Section bg="navy">
            <div className="max-w-2xl">
                {eyebrow && <Eyebrow onNavy>{eyebrow}</Eyebrow>}
                <Heading line1={titleLine1} line2={titleLine2} onNavy className="mt-4" />
                {paragraph && <p className="mt-4 text-lg text-white/70">{paragraph}</p>}
            </div>

            <RevealGroup className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
                {cards.map((c) => (
                    <RevealItem key={c.slug || c.label}
                        className="flex items-center gap-3 rounded-card border border-navy-line bg-navy-card px-5 py-4 transition hover:border-brand hover:bg-brand">
                        <span className="text-2xl">{c.emoji}</span>
                        <span className="font-display font-semibold text-white">{c.label}</span>
                    </RevealItem>
                ))}
            </RevealGroup>
        </Section>
    );
}
